import { NEW_API_ROUTE_ADMIN_DRILL_DOWN_SERVICE } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { DrillDownParamsOriginal, ListResponse } from './types'

import type { ReportEntity } from '../../drilldown/types'

type ProductCategory = ReportEntity & {
  productCategoryId: number
  productCategoryName: string
}

type ProductCategoryResponse = ListResponse<ProductCategory>

const IS_NEW_BACKEND_API = true

export const getDrillDownCategories = async (params: DrillDownParamsOriginal) => {
  const query = new URLSearchParams({ ...params })

  const categoryResult = await get<ProductCategoryResponse>(
    `${NEW_API_ROUTE_ADMIN_DRILL_DOWN_SERVICE}?${query.toString()}`,
    IS_NEW_BACKEND_API
  )

  return {
    ...categoryResult,
    rows: categoryResult.rows.map(category => ({
      ...category,
      amount: Number(category.amount),
      salaryDeductionAmount: Number(category.salaryDeductionAmount),
    })),
  }
}
